<template>
  <w-icon-wrapper
    :height='20.07'
    :width='24'
    icon-name='work-access-config-icon'
    view-box='0 0 24 20.07'
  >
    <g
      id="_90_Zugriffsrechtverwaltung_Icon"
      data-name="90 Zugriffsrechtverwaltung_Icon"
      transform="translate(0.035 -1.2)"
    >
      <g
        id="Gruppe_25618"
        data-name="Gruppe 25618"
      >
        <g
          id="Gruppe_25615"
          data-name="Gruppe 25615"
        >
          <path
            id="Pfad_55842"
            data-name="Pfad 55842"
            d="M10.71,20.06H-.035V17.1a3.279,3.279,0,0,1,1.6-2.84,16.026,16.026,0,0,1,8.061-2.17c.154,0,.308,0,.451.01a7.921,7.921,0,0,0-.563,1.91,14.035,14.035,0,0,0-6.945,1.9,1.364,1.364,0,0,0-.635,1.19v1.04H9.8A8.713,8.713,0,0,0,10.71,20.06Z"
            fill="currentColor"
          />
        </g>
        <g
          id="Gruppe_25616"
          data-name="Gruppe 25616"
        >
          <ellipse
            id="Ellipse_1546"
            data-name="Ellipse 1546"
            cx="4.702"
            cy="4.59"
            rx="4.702"
            ry="4.59"
            transform="translate(4.923 1.2)"
            fill="currentColor"
          />
        </g>
        <g
          id="Gruppe_25617"
          data-name="Gruppe 25617"
        >
          <path
            id="Pfad_55843"
            data-name="Pfad 55843"
            d="M22.623,16.2a4.989,4.989,0,0,0,.072-.73,5.04,5.04,0,0,0-.062-.68l-.02-.13.092-.14,1.26-1.09-1.024-1.74-1.742.58-.112-.1a4.2,4.2,0,0,0-1.26-.71l-.133-.05-.359-1.74H17.276l-.358,1.74-.134.05a4.381,4.381,0,0,0-1.27.71l-.1.1-1.741-.58-1.025,1.74,1.363,1.18-.021.13a4.739,4.739,0,0,0-.072.73,5.337,5.337,0,0,0,.062.7l.02.13-.1.12-1.25,1.09,1.025,1.74,1.741-.58.1.09a4.41,4.41,0,0,0,1.27.72l.134.05.358,1.74h2.059l.359-1.74.133-.05a4.23,4.23,0,0,0,1.26-.72l.112-.09,1.742.58,1.024-1.74L22.6,16.33ZM18.3,18.14a2.671,2.671,0,1,1,2.746-2.67A2.71,2.71,0,0,1,18.3,18.14Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconAccessConfig' };
</script>
